import {onDomReady} from "../../JavaScript/on-dom-ready";

onDomReady(() => {
  const form = document.getElementById("download-center-form");
  const loadingIndicator = document.getElementById("download-center-loading-indicator");
  const hasNavigation = 'navigation' in window;
  form?.addEventListener('submit', (e) => {
    loadingIndicator?.classList.add("loading-indicator--visible");
    if (!hasNavigation) {
      setTimeout(() => loadingIndicator?.classList.remove("loading-indicator--visible"), 10000);
    }
  });
  if (hasNavigation) {
    const nav = (window as any).navigation as EventTarget;
    nav.addEventListener('navigate', (event: Event) => {
      const abortSignal = (event as any).signal as AbortSignal;
      abortSignal.addEventListener('abort', () => {
        // user pressed the cancel button
        loadingIndicator?.classList.remove("loading-indicator--visible");
      });
    })
  }
})

